import { Form } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import MoneyField from 'modules/core/components/MoneyField'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import BudgetExceededOptionSelector, {
  BudgetExceededOptionResultType,
} from 'modules/finance/components/Budgets/BudgetExceededOptionSelector'

interface FormValues {
  limitPerEmployee?: string
  newBudgetLimit?: number
  selectedEmployeeCount: number
}

interface AddEmployeeModalFormProps {
  budgetId: number
  currency: string
  budgetLimit: number
  totalAllocatedAmountCents: number
  form: FormikProps<FormValues>
  displayExtraSection: boolean
  setDisplayExtraSection: (display: boolean) => void
  setSelectorResult: (value: BudgetExceededOptionResultType) => void
  employeeIdsWithBudget: number[]
  onSelectionChange: (selection: EmployeeSelectorV2MultiSelectState) => void
}

const AddEmployeeModalForm = ({
  currency,
  budgetLimit,
  form,
  displayExtraSection,
  totalAllocatedAmountCents,
  setDisplayExtraSection,
  setSelectorResult,
  employeeIdsWithBudget,
  onSelectionChange,
}: AddEmployeeModalFormProps) => {
  const handleOnChange = (value: string) => {
    setDisplayExtraSection(false)
    form.setValues({
      ...form.values,
      limitPerEmployee: value,
    })
    setSelectorResult({
      increaseLimit: 0,
      tryAnotherAllocation: 0,
      type: '',
    })
  }

  const setAllocationValue = (value: number) => {
    form.setFieldValue('limitPerEmployee', value.toString())
  }

  return (
    <Form padding="s0">
      <MoneyField
        currency={currency}
        label={i18n.t('budgets.detail.allocation_per_employee_modal.limit_per_employee')}
        value={form.values.limitPerEmployee}
        onChange={handleOnChange}
        placeholder={'0'}
        error={form.errors.limitPerEmployee}
      />
      <BudgetExceededOptionSelector
        currency={currency}
        budgetLimit={budgetLimit}
        newAllocationValueCents={Number(form.values.limitPerEmployee) * 100}
        numberOfEmployees={form.values.selectedEmployeeCount}
        totalAllocatedAmountCents={totalAllocatedAmountCents}
        setVisible={setDisplayExtraSection}
        visible={displayExtraSection}
        setSelectorResult={setSelectorResult}
        setAllocationValue={setAllocationValue}
        clearErrors={() => form.setErrors({ limitPerEmployee: undefined })}
      />
      {!displayExtraSection && (
        <EmployeeSelectorV2
          multiple
          onChange={onSelectionChange}
          forcedFilters={{ excludeIds: employeeIdsWithBudget }}
        />
      )}
    </Form>
  )
}

export default AddEmployeeModalForm
